import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import styles from "./Customer.module.css";

const AccountDetail = ({ data, isEditable }) => {
  return (
    <div style={{ marginTop: "30px" }}>
      <Row className={styles.detailContainer}>
        <Col className="p-0">Account Detail</Col>
      </Row>
      <>
        <Row style={{ marginTop: 10 }}>
          <Col className={styles.text}>
            Account No: {data?.dwaccountNo ? data.dwaccountNo : "--"}
          </Col>
          <Col className={styles.text}>
            Account Status: {data?.accountStatus || "--"}
          </Col>
          <Col className={styles.text}>
            Extended Hour: {data?.extendedHour ? data.extendedHour : "--"}
          </Col>
        </Row>
        <Row style={{ marginTop: 10 }}>
          <Col className={styles.text}>
            Virtual Account: {data?.virtualAccount ? data.virtualAccount : "--"}
          </Col>
          <Col className={styles.text}>
            Kyc Status: {data?.kycStatus || "--"}
          </Col>
          <Col className={styles.text}>
           
          </Col>
        </Row>
    
      </>
    </div>
  );
};

export default AccountDetail;
